import type { AddProductToCartRequestPayload } from '../types';
import { API } from '@Providers';

export default async function (payload: AddProductToCartRequestPayload) {
  const endpoint = '/api/shelter/animal/add-to-cart';

  return API({ endpoint, method: 'post', payload });
}
